import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import store from "./store/main";

import router from './routes/router';

import { setupInterceptors } from './utils/httpInterceptors';
import httpClient from './utils/httpClient';

import Plugins from './plugins/index';
Vue.use(Plugins);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

httpClient.defaults.withCredentials = true;
httpClient.defaults.baseURL = process.env.VUE_APP_ROOT_API;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    created() {
        setupInterceptors(store);
    },
});